import { $config } from '@client/core/atoms/config.js';
import { $amplitudeExperimentsAtom } from '@client/core/atoms/amplitude.js';
import {
  ExperimentVariants,
  Vertical
} from '@schibsted-nmp/advertising-shared';

import {
  hasSearchQuery,
  isArtAndAntiquesCategory,
  isElectronicsCategory,
  isFurnitureCategory
} from './recommerce-category/index.js';

const experimentVerticals = ['car', 'boat'];

const getExperimentBoatsQuery = (
  query: string,
  experimentVariant: ExperimentVariants
) => {
  const experimentQuery =
    experimentVariant === ExperimentVariants.Treatment_1
      ? 'Både'
      : 'Kategori Både';

  if (query === 'boats') return 'Både';

  return `${query} ${experimentQuery}`;
};

const getExperimentCarsQuery = (
  query: string,
  experimentVariant: ExperimentVariants
) => {
  const experimentQuery =
    experimentVariant === ExperimentVariants.Treatment_1
      ? 'Biler'
      : 'Kategori Biler';

  if (query === 'cars') return 'Biler';

  return `${query} ${experimentQuery}`;
};

export const getExperimentQuery = (query: string) => {
  const { vertical } = $config.get() ?? {};

  if (vertical === Vertical.Recommerce) {
    return getRecommerceExperimentQuery(query);
  }

  const { experiments } = $amplitudeExperimentsAtom.get();
  const experimentVariant = experiments['advt-adsense-context-dba'];

  if (
    !experimentVariant ||
    experimentVariant === ExperimentVariants.Control ||
    !experimentVerticals.includes(vertical as string)
  ) {
    return query;
  }

  if (['boat'].includes(vertical as string)) {
    return getExperimentBoatsQuery(query, experimentVariant);
  }

  return getExperimentCarsQuery(query, experimentVariant);
};

const getRecommerceExperimentQuery = (query: string) => {
  const { experiments } = $amplitudeExperimentsAtom.get();
  const experimentVariant =
    experiments['advertising-adsense-context-dba-recommerce'];

  const isExperimentCategory =
    isArtAndAntiquesCategory() ||
    isElectronicsCategory() ||
    isFurnitureCategory();

  if (
    !experimentVariant ||
    experimentVariant === ExperimentVariants.Control ||
    !isExperimentCategory
  ) {
    return query;
  }

  if (!hasSearchQuery()) return query;

  if (isArtAndAntiquesCategory()) {
    return getQueryWithCategoryName(query, 'Kunst og antik');
  }

  if (isFurnitureCategory()) {
    return getQueryWithCategoryName(query, 'Møbler og indretning');
  }

  return getQueryWithCategoryName(query, 'Elektronik og hvidevarer');
};

const getQueryWithCategoryName = (query: string, categoryName: string) => {
  return query.includes(categoryName) ? query : `${query} ${categoryName}`;
};
